import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Shift} from "../../model/lib/interfaces/Shift";
import {Order} from "../../model/lib/interfaces/Order";
import {OrderChangeOptions} from "../../pages/daymenu-detail/daymenu-detail";

/**
 * Generated class for the ShiftSelectorComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: "shift-selector",
  templateUrl: "shift-selector.html"
})
export class ShiftSelectorComponent {
  public selectedShift: string;

  @Input() shifts: Shift[];
  @Input() ordersMap: Map<number, {
    shift: Shift,
    order: Order,
    orderChangeOptions: OrderChangeOptions
  }>;

  private _shift: Shift;

  @Input()
  set shift(value: Shift) {
    this._shift = value;
    this.selectedShift = this._shift.name;
  }

  get shift(): Shift {
    return this._shift;
  }

  @Output() change: EventEmitter<Shift> = new EventEmitter();

  constructor() {
  }

  changed(shift: Shift) {
    this.change.emit(shift);
  }

  protected isOrderPresentInShift(shift: Shift): boolean {
    if (this.ordersMap.size < 1 || !shift) return false;
    if (!this.ordersMap.get(shift.id)) return false;

    return !!this.ordersMap.get(shift.id).orderChangeOptions.deliveryType && !!this.ordersMap.get(shift.id).order.id;
  }
}



// WEBPACK FOOTER //
// ./src/components/shift-selector/shift-selector.ts